<!-- <app-home-carousel></app-home-carousel> -->

<!-- <app-platform-tab-group></app-platform-tab-group> -->
<app-platform-tab-list></app-platform-tab-list>
